import useSWR, { useSWRConfig } from 'swr';
import { UserPlaylist } from '@bpm-web-app/api-client';

export const getUserPlaylistCategoriesKey = (isDownload: boolean, include_view_only?: boolean) => ['get-user-playlist-categories', { isDownload, include_view_only, persist: true }];

export function useGetUserPlaylistCategories(isDownload: boolean, include_view_only?: boolean) {
    const { mutate } = useSWRConfig();
    const { data, error } = useSWR(getUserPlaylistCategoriesKey(isDownload, include_view_only), () => UserPlaylist.getUserPlaylistCategories(isDownload, include_view_only));

    return {
        data,
        mutate: async () => {
            await Promise.all([
                mutate(getUserPlaylistCategoriesKey(isDownload, true), (d: any) => d, { revalidate: true }),
                mutate(getUserPlaylistCategoriesKey(isDownload, false), (d: any) => d, { revalidate: true }),
                mutate(getUserPlaylistCategoriesKey(isDownload, undefined), (d: any) => d, { revalidate: true })
            ]);
        },
        isLoading: !error && !data,
        error,
    };
}

type UserPlaylistCategoryResponse = Awaited<ReturnType<typeof UserPlaylist['getUserPlaylistCategory']>>;

export function useGetUserPlaylistCategory(id: number | string, isDownload: boolean) {
    const { data, error, mutate } = useSWR<UserPlaylistCategoryResponse>(
        [
            'get-user-playlist-category',
            {
                persist: true,
                isDownload,
                id
            },
        ],
        () => UserPlaylist.getUserPlaylistCategory(id, isDownload)
    );

    return {
        data,
        mutate,
        isLoading: !error && !data,
        error,
    };
}

type UserPlaylistSetsResponse = Awaited<ReturnType<typeof UserPlaylist['getUserPlaylistSets']>>;

export function useUserPlaylistSets(isDownload: boolean, include_view_only?: boolean) {
    const { data, error, mutate } = useSWR<UserPlaylistSetsResponse>(
        [
            'get-user-playlists-sets',
            {
                persist: true,
                isDownload,
                include_view_only
            },
        ],
        () => UserPlaylist.getUserPlaylistSets(isDownload, include_view_only),
    );

    return {
        data,
        mutate,
        isLoading: !error && !data,
        error,
    };
}
